import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, titles } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	text: {
		color: titles,
		fontSize: 13,
		lineHeight: '1.4',
		margin: 0,
	},
	textCollapsed: {
		// Vendor-prefixed properties for CSS line-clamp are not included in CSSProperties type
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		display: '-webkit-box' as any,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		'-webkit-box-orient': 'vertical' as any,
		overflow: 'hidden',
	},
	prefix: {
		fontWeight: 600,
	},
	toggleButton: {
		background: 'none',
		border: 'none',
		padding: 0,
		color: brandPrimaryText,
		fontSize: 12,
		fontWeight: 500,
		cursor: 'pointer',
		alignSelf: 'flex-start',
		':hover': {
			textDecoration: 'underline',
		},
	},
});
